import React from "react";
import {
  Button,
  Dialog as DialogUI,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Toolbar,
  Typography,
} from "@material-ui/core";
import { AppBar } from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import { EntrantTabIndex } from "../../utils/tabIndex";
import { TransitionComponent } from "./TransitionComponent";

type DialogProps = {
  open: boolean,
  onClose?: () => void,
  onSubmit?: () => void,
  ignoreClose?: boolean,
  title?: string,
  labelYes?: string,
  labelNo?: string,
  fullScreen?: boolean,
  bold?: boolean,
  children?: React.ReactNode,
};

const Dialog = ({
  onClose,
  onSubmit,
  ignoreClose,
  open,
  labelYes,
  labelNo,
  title,
  fullScreen,
  bold,
  children,
}: DialogProps) => {
  const submit = () => {
    if (onSubmit) onSubmit();
    if (onClose && !ignoreClose) onClose();
  };
  return (
    <DialogUI
      open={open}
      onClose={onClose}
      fullScreen={fullScreen ? fullScreen : false}
      TransitionComponent={TransitionComponent}
      aria-labelledby="responsive-dialog-title"
    >
      {fullScreen ? (
        <AppBar style={{ position: "relative" }}>
          <Toolbar>
            <IconButton
              edge="start"
              color="inherit"
              onClick={onClose}
              aria-label="close"
              tabIndex={EntrantTabIndex.hidden}
            >
              <CloseIcon />
            </IconButton>
            <Typography variant="h6">{title}</Typography>
          </Toolbar>
        </AppBar>
      ) : (
        <DialogTitle id="responsive-dialog-title">{title}</DialogTitle>
      )}
      <DialogContent style={{ color: "rgba(0, 0, 0, 0.54)" }}>
        {bold ? <b>{children}</b> : children}
      </DialogContent>
      {labelNo || labelYes ? (
        <DialogActions>
          {labelNo && (
            <Button onClick={onClose} color="primary">
              {labelNo}
            </Button>
          )}
          {labelYes && (
            <Button
              onClick={submit}
              variant="contained"
              color="primary"
              autoFocus
            >
              {labelYes}
            </Button>
          )}
        </DialogActions>
      ) : null}
    </DialogUI>
  );
};

export default Dialog;
